import React from "react";

export const SoundBooth: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg {...props} width="82" height="75" viewBox="0 0 82 75" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 24.6722V50.3278H16.6667L37.5 71.7075V3.29247L16.6667 24.6722H0ZM29.1667 23.9453V51.0547L20.125 41.7759H8.33333V33.2241H20.125L29.1667 23.9453ZM56.25 37.5C56.25 29.9316 52 23.4322 45.8333 20.268V54.6893C52 51.5678 56.25 45.0684 56.25 37.5ZM45.8333 0V8.80844C57.875 12.4857 66.6667 23.9453 66.6667 37.5C66.6667 51.0547 57.875 62.5142 45.8333 66.1916V75C62.5417 71.1089 75 55.801 75 37.5C75 19.199 62.5417 3.89111 45.8333 0V0Z" fill="currentColor"/>
</svg>
);
